import { Box, Typography } from '@mui/material';

const Footer = () => (
  <Box
    component="footer"
    sx={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: (theme) => theme.zIndex.appBar,
      backgroundColor: 'background.paper',
      borderTop: '1px solid',
      borderColor: 'divider',
      py: 1,
      textAlign: 'center',
    }}
  >
    <Typography variant="caption" color="text.secondary">
      © 2004–{new Date().getFullYear()} GWC. All Rights Reserved.{' '}
      <a
        href="https://www.gwclogistics.com/privacy-policy/"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: 'inherit', textDecoration: 'underline' }}
      >
        Privacy Policy
      </a>
    </Typography>
  </Box>
);

export default Footer;
